import {
  axiosClient,
  getCSRFToken,
  getFormDataFromObject,
} from 'www/utils'

function sendViewStatusRequest(viewStatusRequestData) {
  const csrfmiddlewaretoken = getCSRFToken()

  if (!csrfmiddlewaretoken) {
    return
  }

  const formViewStatusRequestData = getFormDataFromObject({
    ...viewStatusRequestData,
    csrfmiddlewaretoken,
  })

  axiosClient
    .post('/ajax/view_status/', formViewStatusRequestData)
    .catch(() => {})
}

export default sendViewStatusRequest
